module.exports = __webpack_public_path__ + "static/media/events_icon.6608a023.png";